var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconBtn',{attrs:{"title":"Add","icon":"mdi-plus"},on:{"click":function($event){return _vm.create()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }